<template>

<section class="premium-section">

<h2 class="section-title">Tokenomics</h2>

<p>
Mudra Token (MDR) serves as the core digital asset powering the Mudra creator ecosystem. The token is designed to support reward distribution, platform incentives, and long-term ecosystem growth.
</p>

<p>
The tokenomics model has been structured to ensure sustainability while prioritizing creator rewards. A significant portion of the total token supply is dedicated to rewarding creators who contribute original written content to the platform.
</p>


<h3 class="section-subtitle">Token Details</h3>

<div class="token-grid">

<div class="token-box">
<span class="token-label">Token Name</span>
<span class="token-value">Mudra Token</span>
</div>

<div class="token-box">
<span class="token-label">Symbol</span>
<span class="token-value">MDR</span>
</div>

<div class="token-box">
<span class="token-label">Blockchain</span>
<span class="token-value">Polygon Network</span>
</div>

<div class="token-box">
<span class="token-label">Standard</span>
<span class="token-value">ERC-20</span>
</div>

<div class="token-box">
<span class="token-label">Total Supply</span>
<span class="token-value">100,000,000,000,000 MDR (100 Trillion)</span>
</div>

<div class="token-box">
<span class="token-label">Decimals</span>
<span class="token-value">18</span>
</div>

</div>


<h3 class="section-subtitle">Smart Contract Addresses</h3>

<p>
All Mudra smart contracts are deployed on the Polygon blockchain and can be publicly verified using blockchain explorers such as PolygonScan. This transparency allows anyone to inspect transactions, token supply, and contract logic.
</p>

<table class="premium-table">

<thead>
<tr>
<th>Contract Type</th>
<th>Address</th>
</tr>
</thead>

<tbody>

<tr>
<td>Mudra Token Contract</td>
<td>

<a
href="https://polygonscan.com/address/0x47989a122C0A158b6B8CE2a6c775F37c095A12E0"
target="_blank"
class="contract-link">

0x47989a122C0A158b6B8CE2a6c775F37c095A12E0

</a>

</td>
</tr>

<tr>
<td>Mudra Vesting Contract</td>
<td>

<a
href="https://polygonscan.com/address/0x8E185BBa91280b048909bF4aA1Cfb550D3Bf6708"
target="_blank"
class="contract-link">

0x8E185BBa91280b048909bF4aA1Cfb550D3Bf6708

</a>

</td>
</tr>

</tbody>

</table>


<h3 class="section-subtitle">Token Allocation</h3>

<p>
The total token supply is distributed across several key categories to support platform development, creator rewards, and ecosystem expansion.
</p>

<table class="premium-table">

<thead>
<tr>
<th>Allocation Category</th>
<th>Percentage</th>
<th>Description</th>
</tr>
</thead>

<tbody>

<tr>
<td>Creator Rewards</td>
<td>60%</td>
<td>Tokens reserved for rewarding creators who publish original content on the platform.</td>
</tr>

<tr>
<td>Team Allocation</td>
<td>10%</td>
<td>Tokens allocated to the development team with long-term vesting to ensure commitment.</td>
</tr>

<tr>
<td>Development & Marketing</td>
<td>10%</td>
<td>Used to fund platform development, infrastructure costs, and marketing initiatives.</td>
</tr>

<tr>
<td>Ecosystem Reserve</td>
<td>20%</td>
<td>Reserved for liquidity support, ecosystem growth, and future platform expansion.</td>
</tr>

</tbody>

</table>


<h3 class="section-subtitle">Creator Reward Pool</h3>

<p>
A majority of the total supply is dedicated to creator rewards. This allocation ensures that the Mudra ecosystem remains focused on supporting writers and storytellers.
</p>

<p>
As creators submit original content and contribute to the platform, rewards are gradually distributed from this pool through smart contracts and vesting mechanisms.
</p>


<h3 class="section-subtitle">Long-Term Sustainability</h3>

<p>
The tokenomics model has been carefully designed to maintain long-term sustainability. Controlled reward distribution and vesting mechanisms help prevent excessive token inflation while encouraging consistent participation from creators.
</p>

<p>
This structure supports long-term ecosystem growth while maintaining token supply balance.
</p>


<h3 class="section-subtitle">Utility within the Ecosystem</h3>

<p>
Mudra Tokens function as the primary reward mechanism within the platform. Creators receive tokens for publishing original content, participating in the ecosystem, and contributing to the creative community.
</p>

<p>
As the platform evolves, additional utility may include community incentives, creator economy tools, and expanded ecosystem features.
</p>

</section>

</template>



<style scoped>

/* Token Grid */

.token-grid{
display:grid;
grid-template-columns:repeat(auto-fit,minmax(220px,1fr));
gap:16px;
margin-top:18px;
margin-bottom:20px;
}

/* Token Box */

.token-box{
background:rgba(0,234,255,0.05);
border:1px solid rgba(0,234,255,0.25);
border-radius:10px;
padding:14px;
display:flex;
flex-direction:column;
}

/* Label */

.token-label{
font-size:13px;
color:#9fd9ff;
margin-bottom:4px;
}

/* Value */

.token-value{
font-size:16px;
font-weight:600;
color:#ffffff;
}

/* Contract link color */

.contract-link{
color:#00eaff;
font-weight:600;
text-decoration:none;

/* MOBILE FIX FOR LONG ADDRESS */
word-break: break-all;
overflow-wrap: anywhere;
}

.contract-link:hover{
text-decoration:underline;
}

</style>